import React from 'react'
import { updateCustomerNoteOnPrint } from 'client/utils/api-routes-orders'
import {
  DcFlexBox,
  PixelFactoryContext,
  PixelHeaderPanel,
  PixelSwitch,
  PixelText,
} from 'pixel-base'
import { IPixelFactory, OrderDetail } from '../../../../../decl.d'

interface IProps {
  customerNote: {
    order_comment: string
    print_customer_note_on_shipping_label: boolean
    print_customer_note_on_invoice: boolean
  }[]
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
}
const CustomerNote = (props: IProps) => {
  const { customerNote, details, detailID, setDetails } = props
  const { showFailure, showSuccess } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const printUpdate = (data) => {
    updateCustomerNoteOnPrint(detailID, data).subscribe((res) => {
      if (res.response.data) {
        if (data.print_type === 'shipping-label') {
          setDetails({
            ...details,
            print_customer_note_on_shipping_label: data.print_status,
          })
        } else if (data.print_type === 'invoice') {
          setDetails({
            ...details,
            print_customer_note_on_invoice: data.print_status,
          })
        }
        showSuccess('Updated Successfully')
      } else {
        showFailure('Something went wrong')
      }
    })
  }
  if (!details) return null
  return (
    <DcFlexBox flexDirection="column" height="auto">
      <DcFlexBox
        flexDirection="column"
        justifyContent="flex-start"
        alignContent="center"
        style={{ borderBottom: '1px solid #e6e6e6' }}
        padding="10px 0px"
        height="auto"
      >
        <PixelHeaderPanel>
          <PixelText>Customer Note</PixelText>
        </PixelHeaderPanel>
      </DcFlexBox>
      <DcFlexBox
        flexDirection="column"
        justifyContent="baseline"
        flexWrap="nowrap"
        alignItems="baseline"
        alignContent="flex-start"
        style={{ borderBottom: '1px solid #e6e6e6' }}
        width="100%"
        padding="15px"
        height="auto"
      >
        <PixelText copyTooltipPlacement="top" copyToClipboard>
          {customerNote[0]?.order_comment}
        </PixelText>
      </DcFlexBox>{' '}
      <DcFlexBox
        flexDirection="column"
        justifyContent="baseline"
        flexWrap="nowrap"
        alignItems="baseline"
        alignContent="flex-start"
        width="100%"
        height="auto"
        padding="10px"
        gap="10px"
      >
        <DcFlexBox
          justifyContent="space-between"
          height="auto"
          alignContent="center"
          alignItems="center"
        >
          <PixelText>Print On Shipping Label</PixelText>
          <PixelSwitch
            size="sm"
            label={details.print_customer_note_on_shipping_label ? 'Yes' : 'No'}
            name="is_default"
            checked={details.print_customer_note_on_shipping_label}
            onChange={(e) => {
              printUpdate({
                print_status: e.target.checked,
                print_type: 'shipping-label',
              })
            }}
          />
        </DcFlexBox>
        <DcFlexBox
          justifyContent="space-between"
          height="auto"
          alignContent="center"
          alignItems="center"
        >
          <PixelText>Print On Invoice</PixelText>
          <PixelSwitch
            size="sm"
            label={details.print_customer_note_on_invoice ? 'Yes' : 'No'}
            name="is_default"
            checked={details.print_customer_note_on_invoice}
            onChange={(e) => {
              printUpdate({
                print_status: e.target.checked,
                print_type: 'invoice',
              })
            }}
          />
        </DcFlexBox>
      </DcFlexBox>
    </DcFlexBox>
  )
}

export default CustomerNote
